import { render } from "./QuoteDescription.vue?vue&type=template&id=c71dbaf2&scoped=true"
import script from "./QuoteDescription.vue?vue&type=script&lang=js"
export * from "./QuoteDescription.vue?vue&type=script&lang=js"

import "./QuoteDescription.vue?vue&type=style&index=0&id=c71dbaf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71dbaf2"]])

export default __exports__